import {
  Button,
  CloseCircleOutlined,
  EmptyDataState,
  Flex,
  LoadingDataState,
  Typography,
  useDevice,
} from '@ergolabs/ui-kit';
import { DataStateView } from '@ergolabs/ui-kit/dist/components/dataStates/DataStateView/DataStateView';
import React, { FC } from 'react';

import { KycStatus, kycStatus$ } from '../../api/kycStatus/kycStatus';
import { vestingItems$ } from '../../api/vesting/vesting';
import { isWalletSetuped$ } from '../../api/wallet/wallet';
import { ConnectWalletButton } from '../../common/components/ConnectWalletButton/ConnectWalletButton';
import { useObservable } from '../../common/hooks/useObservable';
import { openKycModal } from '../KycListener/KycListener';
import { ClaimTableItem } from './ClaimTableItem/ClaimTableItem';
import { ClaimTableState } from './types/claimTableState';

export const ClaimTable: FC = () => {
  const { s } = useDevice();

  const [vesting, vestingLoading] = useObservable(vestingItems$);
  const [isWalletConnected] = useObservable(isWalletSetuped$);
  const [kycStatus] = useObservable(kycStatus$);

  let state: ClaimTableState = ClaimTableState.EMPTY;

  if (!isWalletConnected) {
    state = ClaimTableState.CONNECT_WALLET;
  } else if (vestingLoading || kycStatus === KycStatus.LOADING) {
    state = ClaimTableState.LOADING;
  } else if (kycStatus === KycStatus.RETRY) {
    state = ClaimTableState.RETRY;
  } else if (kycStatus !== KycStatus.PASSED) {
    state = ClaimTableState.KYC;
  } else if (!vesting?.public.length && !vesting?.community.length) {
    state = ClaimTableState.NO_VESTING;
  }
  console.log('----logger start----');
  console.log('state', state);
  console.log('kycStatus', kycStatus);
  console.log('----logger end----');

  if (state === ClaimTableState.CONNECT_WALLET) {
    return (
      <EmptyDataState height={250}>
        <Flex col justify="center">
          <Flex.Item marginBottom={2}>
            <Typography.Body>
              Connect wallet to see available claims
            </Typography.Body>
          </Flex.Item>
          <Flex.Item>
            <ConnectWalletButton caption="Connect wallet" size="middle" />
          </Flex.Item>
        </Flex>
      </EmptyDataState>
    );
  }

  if (state === ClaimTableState.LOADING) {
    return (
      <LoadingDataState height={250}>
        <Typography.Body>
          Loading data. <br />
          Please wait.
        </Typography.Body>
      </LoadingDataState>
    );
  }

  if (state === ClaimTableState.RETRY) {
    return (
      <DataStateView height={250}>
        <Flex align="center" justify="center" col>
          <Flex.Item marginBottom={3}>
            <CloseCircleOutlined
              style={{ color: '#7167C5', fontSize: '40px' }}
            />
          </Flex.Item>
          <Flex.Item width="calc(100% - 32px)" maxWidth={620} marginBottom={2}>
            <Typography.Body align="center">
              It appears there was an issue with your initial verification
              documents. To continue using the claiming service, we kindly
              request that you undergo KYC verification once again. You can
              start this process by following the steps outlined by the KYC
              provider. Please click the button below to proceed.{' '}
            </Typography.Body>
          </Flex.Item>
          <Flex.Item marginBottom={2}>
            <Button
              type="primary"
              onClick={() => {
                openKycModal();
              }}
            >
              Retry Verification
            </Button>
          </Flex.Item>
          <Flex.Item>
            <Typography.Body align="center">Support:</Typography.Body>{' '}
            <Button
              href="https://discord.gg/kGp44bdpq7"
              target="_blank"
              type="link"
              size="small"
              style={{
                padding: 0,
                height: 0,
                lineHeight: 0,
                display: 'inline-block',
              }}
            >
              Discord
            </Button>
          </Flex.Item>
        </Flex>
      </DataStateView>
    );
  }

  if (state === ClaimTableState.KYC) {
    return (
      <DataStateView height={250}>
        <Flex align="center" justify="center" col>
          <Flex.Item marginBottom={3}>
            <CloseCircleOutlined
              style={{ color: '#7167C5', fontSize: '40px' }}
            />
          </Flex.Item>
          <Flex.Item width="calc(100% - 32px)" maxWidth={620}>
            <Typography.Body align="center">
              Your Ergo address is not verified. You can’t claim SPF tokens
              using non verified Ergo address. Verification process is not
              available now, because all rounds are over. If you are sure that
              it is a bug, please contact us using{' '}
              <Button
                href="https://discord.gg/kGp44bdpq7"
                target="_blank"
                type="link"
                style={{
                  padding: 0,
                  height: 0,
                  lineHeight: 0,
                  display: 'inline-block',
                }}
              >
                Discord support channel.
              </Button>{' '}
            </Typography.Body>
          </Flex.Item>
        </Flex>
      </DataStateView>
    );
  }

  if (state === ClaimTableState.NO_VESTING) {
    return (
      <EmptyDataState height={250}>
        <Flex col>
          <Flex.Item marginBottom={3}>
            There are no available claims for your wallet
          </Flex.Item>
          <Flex.Item>
            <Button size="middle" href="https://app.spectrum.fi" type="primary">
              Launch App
            </Button>
          </Flex.Item>
        </Flex>
      </EmptyDataState>
    );
  }

  return (
    <Flex.Item display="flex" width="100%" col={s}>
      <Flex.Item flex={1} marginRight={s ? 0 : 4} marginBottom={s ? 4 : 0}>
        <ClaimTableItem
          title="Community round"
          vestingItems={vesting?.community || []}
        />
      </Flex.Item>
      <Flex.Item flex={1}>
        <ClaimTableItem
          title="Public round"
          vestingItems={vesting?.public || []}
        />
      </Flex.Item>
    </Flex.Item>
  );
};
